<template>
  <div class="pa-8">
    <v-row class="pt-4">
      <v-col>
        <home-current-page></home-current-page>
      </v-col>
    </v-row>
    <v-row class="pt-2">
      <v-col cols="12" sm="12" md="6" lg="6">
        <h2 class="title-page">Águas Subterrâneas</h2>
        <h4 class="mt-2 subtitle-page">
          Use o campo de busca para selecionar uma bacia e visualizar dados.
        </h4>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <underground-water-map-search-form
          class="elevation-0"
          @result="searchResult = $event"
          @resultLocation="resultLocation($event)"
          :idClick="idClick"
          from="indicators"
          category="Manancial"
        ></underground-water-map-search-form>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <undergroun-waters-map
          :search-result="searchResult"
          :location="location"
          @idClick="idClick = $event"
        ></undergroun-waters-map>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import HomeCurrentPage from '../../components/common/HomeCurrentPage.vue';
import UndergrounWatersMap from '@/components/undergroundWaters/UndergrounWatersMap.vue';
import UndergroundWaterMapSearchForm from '@/components/undergroundWaters/UndergroundWaterMapSearchForm.vue';

export default {
  name: 'UndergrounWaters',
  components: {
    HomeCurrentPage,
    UndergrounWatersMap,
    UndergroundWaterMapSearchForm,
  },
  data() {
    return {
      searchResult: undefined,
      class: '',
      loading: false,
      value: 0,
      location: undefined,
      showAnimation: false,
      minDaysForecast: 29,
      maxDaysForecast: 6,
      idClick: undefined,
      isProduction: process.env.NODE_ENV === 'production' ? true : false,
    };
  },
  methods: {
    resultLocation(location) {
      this.location = location;
      this.initializeData();
    },
    async initializeData() {
      this.loading = true;
      this.showAnimation = true;
      this.loading = false;
    },
    async getSearchResult(url) {
      this.searchResult = url;
    },
  },
};
</script>

<style scoped>
.title-page {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 33px;
}

.subtitle-page {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
}
</style>
